(() => {
  const menu = document.getElementById('RoveMenu');
  const opener = document.querySelector('[data-menu-open]');
  if (menu && opener) {
    opener.addEventListener('click', () => { menu.showModal(); opener.setAttribute('aria-expanded', 'true'); });
    menu.addEventListener('close', () => opener.setAttribute('aria-expanded', 'false'));
    menu.addEventListener('click', e => { if (e.target === menu && e.clientX > menu.getBoundingClientRect().right) menu.close(); });
  }
  function initProducts(root = document) {
    root.querySelectorAll('[data-variant]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      const form = select.closest('form');
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const purchase = form.closest('.product-purchase');
        purchase.querySelector('[data-price]').textContent = option.dataset.price;
        purchase.querySelector('[data-compare]').textContent = option.dataset.compare;
        const button = form.querySelector('[data-add]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Sold out' : 'Add to bag ↗\uFE0E';
        const quantity = form.querySelector('[name="quantity"]');
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        quantity.value = quantity.min;
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        purchase.querySelector('.theme-product-status').textContent = `${option.textContent.trim()}`;
        const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
      });
    });
  }
  initProducts();
  document.addEventListener('shopify:section:load', e => { initProducts(e.target); initWaitlists(e.target); });
  // Decorative motion mirrors the prototype and is disabled for reduced motion.
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches && matchMedia('(min-width: 761px)').matches) {
    let frame;
    const paint = () => {
      document.querySelectorAll('[data-dive]').forEach(el => {
        const bounds = el.getBoundingClientRect();
        const p = Math.max(0, Math.min(1, -bounds.top / Math.max(1, bounds.height - innerHeight)));
        const handoff = Math.max(0, Math.min(1, (p - .52) / .48));
        const values = { '--dive': p, '--dive-scale': 1.04+p*.34, '--dive-y': -p*7+'%', '--dive-x': p*7+'%', '--dive-glimmer-y': p*5+'%', '--dive-object-y': p*22+'vh', '--dive-note-y': -p*7+'vh', '--dive-note-opacity': p<.68?1:Math.max(0,1-(p-.68)/.24), '--dive-depth-opacity': .35+p*.65, '--dive-exit-y': (1-handoff)*104+'%', '--dive-handoff-y': (1-handoff)*12+'vh', '--dive-handoff-opacity': handoff };
        for (const [key,value] of Object.entries(values)) el.style.setProperty(key,value);
      });
      frame = null;
    };
    const request = () => { if (!frame) frame = requestAnimationFrame(paint); };
    addEventListener('scroll', request, {passive:true}); addEventListener('resize', request); paint();
  }
  function initWaitlists(root = document) {
    root.querySelectorAll('.wl-preview-form').forEach(form => {
      if (form.dataset.ready) return; form.dataset.ready='true';
      form.querySelector('.wl-submit').disabled=false;
      const fields=form.querySelector('[data-wl-fields]'), success=form.querySelector('.wl-success'), error=form.querySelector('.wl-error');
      form.addEventListener('change', () => {
        const texture=form.querySelector('[name="texture"]:checked');
        form.querySelector('.wl-lengths').disabled=!texture;
        form.querySelector('[data-length-help]').textContent=texture?'Choose one or more.':'Select a texture to see its lengths.';
        const short=form.querySelector('[data-short-length]');
        short.hidden=texture?.value!=='VERDE';
        short.querySelector('input').disabled=short.hidden;
        if(short.hidden)short.querySelector('input').checked=false;
        error.textContent='';
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        const lengths=[...form.querySelectorAll('[name="length"]:checked')].map(el=>el.value);
        if(!lengths.length){error.textContent='Choose at least one preferred length.'; form.querySelector('.wl-lengths input:not([disabled])')?.focus();return;}
        success.querySelector('.wl-summary').textContent=form.querySelector('[name="texture"]:checked').value+' · '+lengths.join(' / ');
        fields.hidden=true; success.hidden=false; success.querySelector('h2').focus();
      });
      form.querySelector('[data-wl-back]').addEventListener('click',()=>{success.hidden=true;fields.hidden=false;form.querySelector('[name="texture"]:checked')?.focus();});
    });
  }
  initWaitlists();
})();
